
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from 'react-hook-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare, faCheck, faHome, faLink, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Badge, Breadcrumb, Button, Card, Form, Table } from '@themesberg/react-bootstrap';
import { sendError, sendSuccess } from "../helpers/Helper";
import { Model } from "../components/Model";
import { Textbox } from "../components/Textbox";
import { API_URL_ENDPOINT } from "../appsetting";
import { Link, useNavigate} from "react-router-dom";
import { Routess } from "../Routes/routes";
import { useApi } from "../helpers/useApi";
import Switch from "@themesberg/react-bootstrap/lib/esm/Switch";
import { TreeNode } from "../components/TreeNode";

export const FileExplorer = () => {
  const api = useApi();
  const [openModel, setOpenModel] = useState(false);
  const navigate = useNavigate();
  const methods = useForm();
  const { register,handleSubmit, reset, formState: { errors, isSubmitting }, watch , setValue } = methods;

  const [visiblePasswords, setVisiblePasswords] = useState({});
  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(()=>{
    getData();
  },[])

  const togglePasswordVisibility = (id) => {
    setVisiblePasswords(prevState => ({
      ...prevState,
      [id]: !prevState[id] // Toggle the specific row's visibility
    }));
  };

  const getData = async (path = null) => {
    try{
      setDataLoading(true);
      const response = await api(API_URL_ENDPOINT.Files+`?path=${path ? path : ""}`);
      if(response.status){
        setData(response.data);
      }
    }catch{
      setData([]);
    }finally{
      setDataLoading(false);
    }
  }

  const handleView = (id) => {
    navigate(Routess.NewsAndEvent.path + `/${id}`)
  }

  return (
    <>
      <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item active>File Explorer</Breadcrumb.Item>
          </Breadcrumb>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">
              File Explorer
            </h4>
          </div>
        </div>
      </div>

      {/* <PageTrafficTable /> */}
      {/* <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="pb-0"> */}
          {dataLoading ? (
            <div className="text-center my-3">
              <span className="spinner-border text-primary" role="status"></span>
              {/* <p>Loading News & Events...</p> */}
            </div>
          ) : (
      <ul style={{ listStyleType: "none", paddingLeft: "0" }}>
        {data?.map(node => (
          <TreeNode key={node.path} node={node} />
        ))}
      </ul>
          )}
        {/* </Card.Body>
      </Card> */}
    </>
  );
};
